import { useState } from "react";
import { Register } from "../components/register";
import { UpdateUser } from "../components/updateUser";
import { ResetUserPassword } from "../components/resetUserPassword";
import './App.css';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LockResetIcon from '@mui/icons-material/LockReset';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function Admin() {
  const [panel, setPanel] = useState(null); // null | 'create' | 'update' | 'reset'

  const isAdmin = localStorage.getItem('canAdmin') === '1';

  if (!isAdmin) {
    return (
      <Card sx={{ p: 4, maxWidth: 520, mx: 'auto', textAlign: 'center' }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Admin</Typography>
        <Typography sx={{ color: 'var(--muted)', mt: 1 }}>
          You do not have permission to manage users.
        </Typography>
      </Card>
    );
  }

  const menu = [
    { key: 'create', label: 'Create a New User', icon: <PersonAddIcon /> },
    { key: 'update', label: 'Update User', icon: <ManageAccountsIcon /> },
    { key: 'reset', label: 'Reset User Password', icon: <LockResetIcon /> },
  ];

  if (panel) {
    return (
      <Box>
        <Button startIcon={<ArrowBackIcon />} onClick={() => setPanel(null)} sx={{ mb: 2 }} color="inherit" variant="outlined">
          Back to Admin
        </Button>
        {panel === 'create' && <Register />}
        {panel === 'update' && <UpdateUser />}
        {panel === 'reset' && <ResetUserPassword />}
      </Box>
    );
  }

  return (
    <Card sx={{ p: { xs: 2.5, md: 3.5 }, maxWidth: 720, mx: 'auto' }}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>Admin</Typography>
      <Typography sx={{ color: 'var(--muted)', mb: 3 }}>Manage user accounts and permissions.</Typography>
      <Grid container spacing={2}>
        {menu.map((m) => (
          <Grid item xs={12} sm={6} key={m.key}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={m.icon}
              onClick={() => setPanel(m.key)}
              sx={{ py: 1.5, justifyContent: 'flex-start', borderColor: 'var(--border-strong)', color: 'var(--text)' }}
            >
              {m.label}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

export default Admin;
